export default __webpack_public_path__ + "static/media/Icon-memo-new.f8f2e7a6.svg";